module.exports = __webpack_public_path__ + "static/media/Tawuniya-Logo-light.cf435b63.svg";